export const getISP = function () {
  return globalThis.utag_data && globalThis.utag_data.isp
    ? globalThis.utag_data.isp.toLowerCase()
    : ''
}
